/**
 * Default Renderer
 *
 * Fallback for unknown operation types.
 * Displays raw process data as key-value pairs.
 */

import { FC } from 'react';
import { Code, Stack, Text } from '@mantine/core';
import type { DetailRendererProps, OperationRendererConfig } from './index';
import classes from './OperationRenderers.module.css';

const DetailComponent: FC<DetailRendererProps> = ({ process, t }) => {
  const data = process.data || {};

  return (
    <Stack gap="xs">
      <Text fz="sm" c="dimmed">
        {t( 'batchProcesses_detail_unknownOperation' )}
      </Text>
      {/*
        Mantine's `Code` already carries `overflow: auto`, so the `<pre>` is its
        own scroll container and a wide JSON line cannot widen the DOCUMENT. The
        class only bounds its HEIGHT on a phone — an unknown operation with a
        large `data` payload would otherwise push the Results section several
        screens down. Inert at >= 768px.
      */}
      <Code block className={classes.defaultJson}>
        {JSON.stringify( data, null, 2 )}
      </Code>
    </Stack>
  );
};

export const config: Omit<OperationRendererConfig, 'icon' | 'color' | 'labelKey'> = {
  getSummary: ( _data, _t, process ) => process?.operationName ?? 'Unknown',
  DetailComponent,
  getRequiredReferenceIds: () => ({})
};

export default DetailComponent;
